import React, { useRef } from "react"
import {
    Avatar,
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    IconButton,
    Typography,
} from "@mui/material"
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined"
import CloseIcon from "@mui/icons-material/Close"

interface PhotoOptionsDrawerProps {
    setImages: React.Dispatch<React.SetStateAction<string[]>>
    cameraOpen: () => void
}

const MediaOptionsDrawer: React.FC<PhotoOptionsDrawerProps> = ({ cameraOpen, setImages }) => {
    const [openDrawer, setOpenDrawer] = React.useState(false)
    const fileInputRef = useRef<HTMLInputElement | null>(null)
    const photoLibraryRef = useRef<HTMLInputElement | null>(null)

    // Function to trigger file selection
    const openFilePicker = () => {
        fileInputRef.current?.click()
    }

    // Function to trigger photo library selection
    const openPhotoLibrary = () => {
        photoLibraryRef.current?.click()
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files?.length) {
            const file = event.target.files[0]
            const reader = new FileReader()

            reader.onload = (e) => {
                if (e.target?.result) {
                    setImages((prev) => [...prev, e.target?.result as string])
                    setOpenDrawer(false)
                }
            }

            reader.readAsDataURL(file)
        }
    }

    const options = [
        { text: "Take Photo", onClick: cameraOpen },
        { text: "Choose Files", onClick: openFilePicker },
        { text: "Photo Library", onClick: openPhotoLibrary },
    ]

    return (
        <Box display="flex" flexDirection="column" alignItems="center">
            {/* Avatar Button to Open Drawer */}
            <Avatar
                sx={{
                    bgcolor: "primary.contrast",
                    color: "white",
                    padding: { xs: 4, sm: 4.5, md: 5 },
                    marginY: { xs: 1.5, sm: 2.5, md: 3 },
                }}
                onClick={() => setOpenDrawer(true)}
            >
                <CameraAltOutlinedIcon />
            </Avatar>

            {/* Hidden file inputs */}
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                accept="*/*"
                onChange={handleFileChange}
            />
            <input
                type="file"
                ref={photoLibraryRef}
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleFileChange}
            />

            {/* Bottom Drawer */}
            <Drawer
                anchor="bottom"
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                sx={{
                    "& .MuiDrawer-paper": {
                        borderRadius: "20px 20px 0px 0px",
                        padding: 2,
                        backgroundColor: "#00263a",
                    },
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" paddingX={2}>
                    <Typography variant="h6">Upload Files</Typography>
                    <IconButton onClick={() => setOpenDrawer(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <List>
                    {options.map((option, index) => (
                        <ListItem key={index} disablePadding>
                            <ListItemButton onClick={option.onClick}>
                                <ListItemText primary={option.text} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </Box>
    )
}

export default MediaOptionsDrawer
